module.exports = __webpack_public_path__ + "static/img/1.9971aed.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1.gif
// module id = bsKc
// module chunks = 13